/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Theme, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
// import Divider from '@mui/material/Divider';
import React from 'react';
// import CustomerReview from './customer_review';
import SocialMedia from './social_media';

function SocialAndReview(): JSX.Element {
  const theme: Theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        // justifyContent: { xs: 'space-between', xl: 'space-evenly' },
        justifyContent: { xs: "center" },
        flexDirection: { xs: 'column', md: 'row' },
        padding: {
          xs: theme.spacing(3, 1),
          sm: theme.spacing(3, 2),
          md: theme.spacing(12, 2),
          lg: theme.spacing(12, 10),
        },
      }}
    >
      <SocialMedia />
      {/* <Divider
        sx={{
          display: { xs: 'none', md: 'block' },
        }}
        variant='middle'
        orientation='vertical'
        flexItem
      /> */}
      {/* <Divider
        sx={{
          display: { xs: 'block', md: 'none' },
        }}
        variant='middle'
        orientation='horizontal'
        flexItem
      /> */}
      {/* <CustomerReview /> */}
    </Box>
  );
};

export default SocialAndReview;
